export default "__VITE_ASSET__JKLBdQSd__"